import { MEETING_MUTATIONS } from '../mutations/meeting.mutations';
import { Meeting } from '../models/meeting.model';
import { User } from '@/core/models/user.model';
import KEYS from '@/values/keys';

export const MEETINGS_ACTION = {
  GET_MEETINGS_OF_TEACHER: 'getMeetingsOfTeacher',
  GET_MEETINGS_OF_STUDENT: 'getMeetingsOfStudent',
  REMOVE_MEETING: 'removeMeeting',
  CREATE_MEETING: 'createMeeting',
  UPDATE_MEETING: 'updateMeeting',
  SET_MEMBERS_MEETING: 'setMembersMeeting',
  GET_MEMBERS_MEETING: 'getMembersMeeting',
  GET_CREATOR_INFO: 'getCreatorInfo',
  GET_USERS_ORGANIZATION: 'getUsersOrganization'
};

export interface ISetMembersAction {
  users: User[];
  meetingId: number;
}

export interface ICreateMeetingAction {
  name: string;
  description?: string;
  startingDate: string;
  endingDate: string;
}

class MeetingActionClass {
  
  constructor() {}

  public getMeetingsOfStudent(ctx: any) {    
    // return RequestProvider.get(ctx.getters.urlMeetingsStudent).then((res: any) => {
    //   ctx.commit(MEETING_MUTATIONS.SET_MEETINGS, res.data);
    // });
  }

  public getMeetingsOfTeacher(ctx: any) {
    // return RequestProvider.get(ctx.getters.urlMeetingsTeacher).then((res: any) => {
    //   ctx.commit(MEETING_MUTATIONS.SET_MEETINGS, res.data);
    // });
  }
  
  public removeMeeting(ctx: any, meeting: Meeting) {
    // let req = {...meeting, archived: true, createdBy: ctx.state.user.id };
    // return RequestProvider.post(ctx.getters.urlMeeting, req).then((res: any) => {
    //   ctx.commit(MEETING_MUTATIONS.REMOVE_MEETING, meeting);
    // });
  }

  public createMeeting(ctx: any, meeting: Meeting) {
    // return new Promise((resolve, reject) => {
    //   RequestProvider.post(ctx.getters.urlMeeting, meeting, KEYS.JSON_HEADERS).then((res: any) => {
    //     let meetingSaved = new Meeting(res.data);
    //     ctx.commit(MEETING_MUTATIONS.CREATE_MEETING, meetingSaved);
    //     resolve(meetingSaved.meetingId);
    //   }).catch((err) => {
    //     reject(err);
    //   });
    // });
  }

  public updateMeeting(ctx: any, meeting: Meeting) {
    // return new Promise((resolve, reject) => {
    //   let req = {...meeting, createdBy: ctx.state.user.id };
    //   RequestProvider.post(ctx.getters.urlMeeting, req).then((res: any) => {
    //   let meetingSaved = new Meeting(res.data);
    //   ctx.commit(MEETING_MUTATIONS.UPDATE_MEETING, meetingSaved);
    //   resolve(meetingSaved.meetingId);
    //   }).catch((err) => {
    //     reject(err);
    //   });
    // });
  }

  public setMembersMeeting(ctx: any, data: ISetMembersAction) {
    // return new Promise((resolve, reject) => {
    //   let members = data.users.map(u => { return u.id });
    //   RequestProvider.post(`${ctx.getters.urlMeeting}/${data.meetingId}/attendees`, members).then((res: any) => {
    //     ctx.commit(MEETING_MUTATIONS.SET_MEMBERS_MEETING, data);
    //     resolve();
    //   }).catch(() => {
    //     reject();
    //   });
    // });
  }

  public getMembersMeeting(ctx: any, meeting: Meeting) {
    // return RequestProvider.get(`${ctx.getters.urlMeeting}/${meeting.meetingId}/attendees`).then((res: any) => {
    //   let users: User[] = res.data.map((u: User) => { return new User(u); });
    //   ctx.commit(MEETING_MUTATIONS.SET_MEMBERS_MEETING, { users, meetingId: meeting.meetingId });
    // });
  }

  public getCreatorInfo(ctx: any) {
    // return RequestProvider.get(ctx.getters.urlCreator).then((res: any) => {
    //   ctx.commit(MEETING_MUTATIONS.SET_USER_INFO, new User(res.data.person));
    // });
  }

  public getUsersOrganization(ctx: any, params: any) {
    // return new Promise((resolve, reject) => {
    //   RequestProvider.get(`${ctx.getters.urlUsersOrganization}?page=${params.page}&pageSize=${params.pageSize}&keyword=${params.search}`).then((res: any) => {
    //     ctx.commit(MEETING_MUTATIONS.SET_USERS_ORGANIZATION, { users: res.data.content, add: params.add });
    //     resolve(res.data.content.length);
    //   }).catch(() => {
    //     reject();
    //   }); 
    // });
  }

}

export const MeetingActions = new MeetingActionClass();
